import * as React from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router";

import { Header } from "../../../components/atoms";
import { AddressCreate } from "../../../components/organisms/address-management/address-create";
import { AddressSelect } from "../../../components/organisms/address-management/address-select";
import { AddressUpdate } from "../../../components/organisms/address-management/address-update";
import { CenteredTemplate } from "../../../components/templates/centered";
import { OrderSummaryContainer } from "../../../containers/booking";
import { Column, Container, Row } from "../../grid";
import { metaData } from "../../../static/meta";
import { ITherapist } from "../../../services/api/therapists";
import { IRootState } from "../../../store/index";

interface IReduxProps {
  therapist?: ITherapist;
}

type Props = IReduxProps & RouteComponentProps;

const AddressPageHeaderRow = Row.extend`
  margin-bottom: 30px;

  @media screen and (max-width: 992px) {
    margin-bottom: 0;
  }
`;

const AddressPageSummaryColumn = Column.extend`
  padding-left: 100px;

  @media screen and (max-width: 992px) {
    order: -1;
  }
`;

const AddressPageBookingRow = Row.extend`
  @media screen and (max-width: 992px) {
    flex-direction: column-reverse;
    margin-bottom: 50px;

    ${AddressPageSummaryColumn} {
      padding: 0 5%;
    }
  }
`;

const Component: React.FC<Props> = (props: Props) => {
  if (!props.therapist) {
    return <Redirect to="/" />;
  }

  return (
    <CenteredTemplate>
      <Container offsetPaddings>
        <Helmet>
          <title>{metaData.checkout.title}</title>
          <meta name="description" content={metaData.checkout.description} />
        </Helmet>
        <AddressPageHeaderRow>
          <Column textAlign="center">
            <Header>Review &amp; Checkout</Header>
          </Column>
        </AddressPageHeaderRow>
        <AddressPageBookingRow>
          <Column md="7">
            <Switch>
              <Route
                exact={true}
                path={"/address/:type/select"}
                render={() => <AddressSelect />}
              />
              <Route
                exact={true}
                path={"/address/new"}
                render={() => <AddressCreate />}
              />
              <Route
                exact={true}
                path={"/address/:urn/edit"}
                render={() => <AddressUpdate />}
              />
            </Switch>
          </Column>
          <AddressPageSummaryColumn md="5">
            <OrderSummaryContainer />
          </AddressPageSummaryColumn>
        </AddressPageBookingRow>
      </Container>
    </CenteredTemplate>
  );
};

const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    therapist: state.therapistsState.selectedTherapist,
  };
};

export const AddressPage = withRouter(
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(Component),
);
